//Core
import React from "react"

//Style
import style from "./style.module.scss"

const { Container, TextWrapper, Check, Bonus, Info } = style

const BonusHeader = () => {
  return (
    <div className={Container}>
      <div className={TextWrapper}>
        <h2 className={Check}>
          Протягом місяця здійсніть покупки та використайте кредитний ліміт на
          Вашу «щасливу суму», вказану в sms / viber, і отримайте
        </h2>
        <h1 className={Bonus}>подвійний кешбек!</h1>
        <h3 className={Info}>
          Пропозиція діє з 01 січня 2020 по 31 січня 2020 року
        </h3>
      </div>
    </div>
  )
}

export default BonusHeader
